/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Billing_Addon_ReviewerInputs */

const en_billing_addon_reviewer = /** @type {(inputs: Billing_Addon_ReviewerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.n} Pemeriksa reviews`)
};

const id_billing_addon_reviewer = /** @type {(inputs: Billing_Addon_ReviewerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.n} pemeriksaan Pemeriksa`)
};

/**
* | output |
* | --- |
* | "+{n} Pemeriksa reviews" |
*
* @param {Billing_Addon_ReviewerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_addon_reviewer = /** @type {((inputs: Billing_Addon_ReviewerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Addon_ReviewerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_addon_reviewer(inputs)
	return en_billing_addon_reviewer(inputs)
});